// KP-4363: one order confirmation download per confirmation stage
// ("<orderSeqId>-C<n>") of a partially confirmed or confirmed order.

export const CONFIRMATION_STAGE_PDF = 'confirmationStagePdf'

// Stages written before the ID was stored have none; same fallback as the API.
const confirmationSeqIdOf = (order, stage, index) => stage.confirmationSeqId || `${order.orderSeqId}-C${index + 1}`

/** The order's stages that were not reverted, each with its confirmation ID. */
export function getOpenConfirmationStages(order) {
  return (order?.confirmationStages || [])
    .map((stage, index) => ({ ...stage, confirmationSeqId: confirmationSeqIdOf(order, stage, index) }))
    .filter(stage => !stage.revertedAt)
}

/** Download modal options, one per open stage. */
export function getConfirmationStageDownloadOptions(order) {
  return getOpenConfirmationStages(order).map(({ confirmationSeqId }) => ({
    text: `Order Confirmation ${confirmationSeqId}`,
    value: `${CONFIRMATION_STAGE_PDF}:${confirmationSeqId}`,
    confirmationSeqId,
  }))
}

export const isConfirmationStageOption = option => !!option?.confirmationSeqId
